import {
	SET_BRANDING_ARRAY,
	SET_BRAND,
	SET_COMPANY,
	SET_MODE,
	SET_BRANDING_VARS
} from './branding-mutation-types';
import api from '@/services/api-service';

export default {
	strict: process.env.NODE_ENV !== 'production',
	name: 'branding',
	namespaced: true,
	state: {
		brandingArray: [],
		activeMode: 'light',
		brandingVars: {},
		brand: {},
		company: {}
	},
	mutations: {
		[SET_BRANDING_ARRAY](state, branding) {
			state.brandingArray = branding;
		},
		[SET_BRAND](state, brand) {
			state.brand = brand;
		},
		[SET_COMPANY](state, company) {
			state.company = company;
		},
		[SET_BRANDING_VARS](state, brandingVars) {
			let vars = {};

			for (const prop in brandingVars) {
				vars[`--${prop}`] = brandingVars[prop];
			}

			state.brandingVars = vars;
		},
		[SET_MODE](state, mode) {
			state.activeMode = mode;
		}
	},
	actions: {
		// actions let us get to ({ state, getters, commit, dispatch }) {
		async getBrandingAction({ commit }) {
			const branding = await api.get('/branding');
			commit(SET_BRANDING_ARRAY, branding);
		},
		setBrandAction({ commit, state }, dealershipGroupId) {
			const brand = state.brandingArray.find(b => {
				return b.id == dealershipGroupId;
			});
			commit(SET_BRAND, brand);
		},
		setCompanyAction({ commit, state }, companyId) {
			let companyVars = {};
			let company = {};

			if (state.brand && parseInt(companyId) > 0) {
				company = state.brand.companies.find(c => {
					return c.id == companyId;
				});
			}

			commit(SET_COMPANY, company);

			if (company) {
				companyVars = company.vars;
			}

			commit(SET_BRANDING_VARS, companyVars);
		},
		setMode({ commit }, mode) {
			commit(SET_MODE, mode);
		}
	},
	getters: {
		activeMode: state => state.activeMode,
		brandingArray: state => state.brandingArray,
		brandingVars: state => state.brandingVars,
		brand: state => state.brand,
		company: state => state.company
	}
};
